import React from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Contentmanagementexbitors from '../sections/content-management-exhibitors';




const Contentmangemnt4 = () => {

     const [isSidebarOpen, setIsSidebarOpen] = useState(false);    
    return ( 
                 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>
                
                <Contentmanagementexbitors />

            </section>
    </section>
     );
}
 
export default Contentmangemnt4;